import { Stack, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { CopyText, HelpTooltip } from 'components';

type Props = {
  title: string;
  value?: ReactNode;
  canCopy?: boolean;
  description?: string;
};

export const DescriptionRow: FC<Props> = ({
  title,
  value,
  canCopy,
  description,
}) => (
  <Stack direction="column" spacing={0.5}>
    <Typography variant="subtitle2">
      {title}
      {description && <HelpTooltip title={description} />}
    </Typography>
    {canCopy && typeof value === 'string' ? (
      <CopyText text={value} />
    ) : (
      value || '-'
    )}
  </Stack>
);
